import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { requestEarningsQuantities } from "./earningsQuantities.request";
import { EarningsQuantitiesResponse } from "./earningsQuantities.types";

const useEarningsQuantities = (
  options?: QueryOptions<EarningsQuantitiesResponse, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["earningsQuantities"],
    queryFn: requestEarningsQuantities,
    ...options
  });

  return { earningsQuantities: data, ...rest };
};

export default useEarningsQuantities;
